import { P as e } from "./index-057d60ee.js";
import { s as N } from "./styled-a6aa6ca0.js";
import { a as R, u as D } from "./useThemeProps-14bb9b11.js";
import { _ as F } from "./objectWithoutPropertiesLoose-1e2b28af.js";
import { _ as T } from "./extends-0a3e0827.js";
import * as d from "react";
import { c as _ } from "./clsx-0c6e471a.js";
import { c as E } from "./createStyled-4c27adb8.js";
import { a as B, h as O, r as f, e as G, j as M, m as $, g as w, k as b } from "./createTheme-ef7fa3a1.js";
import { jsx as U } from "react/jsx-runtime";
import { e as A } from "./extendSxProp-10687d60.js";
import { c as L } from "./composeClasses-8a61f9a6.js";
const I = E(), W = I, q = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], z = B(), H = W("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (o, r) => r.root
});
function J(o) {
  return R({
    props: o,
    name: "MuiStack",
    defaultTheme: z
  });
}
function K(o, r) {
  const c = d.Children.toArray(o).filter(Boolean);
  return c.reduce((i, a, t) => (i.push(a), t < c.length - 1 && i.push(/* @__PURE__ */ d.cloneElement(r, {
    key: `separator-${t}`
  })), i), []);
}
const Q = (o) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[o], X = ({
  ownerState: o,
  theme: r
}) => {
  let c = T({
    display: "flex",
    flexDirection: "column"
  }, O({
    theme: r
  }, f({
    values: o.direction,
    breakpoints: r.breakpoints.values
  }), (i) => ({
    flexDirection: i
  })));
  if (o.spacing) {
    const i = G(r), a = Object.keys(r.breakpoints.values).reduce((s, n) => ((typeof o.spacing == "object" && o.spacing[n] != null || typeof o.direction == "object" && o.direction[n] != null) && (s[n] = !0), s), {}), t = f({
      values: o.direction,
      base: a
    }), l = f({
      values: o.spacing,
      base: a
    });
    typeof t == "object" && Object.keys(t).forEach((s, n, p) => {
      if (!t[s]) {
        const m = n > 0 ? t[p[n - 1]] : "column";
        t[s] = m;
      }
    }), c = M(c, O({
      theme: r
    }, l, (s, n) => o.useFlexGap ? {
      gap: b(i, s)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${Q(n ? t[n] : o.direction)}`]: b(i, s)
      }
    }));
  }
  return c = $(r.breakpoints, c), c;
};
function Y(o = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: r = H,
    useThemeProps: c = J,
    componentName: i = "MuiStack"
  } = o, a = () => L({
    root: ["root"]
  }, (s) => w(i, s), {}), t = r(X), l = /* @__PURE__ */ d.forwardRef(function(s, n) {
    const p = c(s), u = A(p), {
      component: m = "div",
      direction: j = "column",
      spacing: k = 0,
      divider: v,
      children: g,
      className: x,
      useFlexGap: P = !1
    } = u, S = F(u, q), V = {
      direction: j,
      spacing: k,
      useFlexGap: P
    }, C = a();
    return /* @__PURE__ */ U(t, T({
      as: m,
      ownerState: V,
      ref: n,
      className: _(C.root, x)
    }, S, {
      children: v ? K(g, v) : g
    }));
  });
  return process.env.NODE_ENV !== "production" && (l.propTypes = {
    children: e.node,
    direction: e.oneOfType([e.oneOf(["column-reverse", "column", "row-reverse", "row"]), e.arrayOf(e.oneOf(["column-reverse", "column", "row-reverse", "row"])), e.object]),
    divider: e.node,
    spacing: e.oneOfType([e.arrayOf(e.oneOfType([e.number, e.string])), e.number, e.object, e.string]),
    sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
  }), l;
}
const h = Y({
  createStyledComponent: N("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (o, r) => r.root
  }),
  useThemeProps: (o) => D({
    props: o,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (h.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: e.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: e.oneOfType([e.oneOf(["column-reverse", "column", "row-reverse", "row"]), e.arrayOf(e.oneOf(["column-reverse", "column", "row-reverse", "row"])), e.object]),
  /**
   * Add an element between each child.
   */
  divider: e.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: e.oneOfType([e.arrayOf(e.oneOfType([e.number, e.string])), e.number, e.object, e.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: e.bool
});
const pe = h;
export {
  pe as S
};
//# sourceMappingURL=Stack-fdcae5f7.js.map
